import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';
export enum ArrowIconVariant {
  BACK = 'back',
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  PREVIOUS = 'previous',
  PREVIOUS_EP = 'previous_ep',
  PREVIOUS_AD = 'previous_ad',

  MOVE_L = 'move_l',
  MOVE_R = 'move_r',
  MOVE_L_DARK = 'move_l_dark',
  IMAGE_SLIDE_R = 'image_slide_r',
  IMAGE_SLIDE_CHEVRON = 'image_slide_chevron',
  TRIGGER_IMAGES_SLIDER_R = 'trigger_images_slider_r',
}

export interface IArrowIconProps extends IConDefaultType {
  variant?: ArrowIconVariant;
}

function ArrowIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = ArrowIconVariant.BACK,
  style,
}: IArrowIconProps) {
  const theme = useTheme();
  const fill = color || theme.color.icon.icon_3;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === ArrowIconVariant.BACK && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            transform="translate(4 4)"
            d="M7.29305 0.292897C7.68358 -0.0976322 8.31661 -0.0976322 8.70713 0.292897C9.09763 0.683429 9.09765 1.31646 8.70713 1.70698L3.4141 7.00001H15.0002C15.5525 7.00001 16.0002 7.44773 16.0002 8.00002C16.0001 8.55228 15.5524 9.00003 15.0002 9.00003H3.4141L8.70713 14.2931C9.09763 14.6836 9.09765 15.3166 8.70713 15.7071C8.31661 16.0976 7.68357 16.0976 7.29305 15.7071L0.292972 8.70706C0.261836 8.67592 0.234182 8.6424 0.20801 8.60842C0.194231 8.59052 0.180534 8.57258 0.167971 8.55374C0.141957 8.51475 0.11956 8.47415 0.0996106 8.43264C0.0776679 8.38706 0.0578829 8.34013 0.0429693 8.29104C0.0378967 8.27431 0.0344507 8.25718 0.0302738 8.24026C0.0112456 8.16321 6.11311e-06 8.08294 0 8.00002C0 7.92034 0.00973771 7.84287 0.0273441 7.76857C0.0322132 7.74802 0.0367837 7.72732 0.0429693 7.70705C0.0578709 7.6583 0.0777732 7.61169 0.0996106 7.56642C0.118774 7.52663 0.1403 7.4877 0.165041 7.45021C0.20242 7.39355 0.245164 7.34079 0.292972 7.29298L7.29305 0.292897Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.VERTICAL && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.HORIZONTAL && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7071 6.29289C15.0976 6.68342 15.0976 7.31658 14.7071 7.70711L10.4142 12L14.7071 16.2929C15.0976 16.6834 15.0976 17.3166 14.7071 17.7071C14.3166 18.0976 13.6834 18.0976 13.2929 17.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L13.2929 6.29289C13.6834 5.90237 14.3166 5.90237 14.7071 6.29289Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.PREVIOUS && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.5268 3.99993C16.4123 3.99432 17.2648 4.3354 17.9021 4.95023C18.5393 5.56506 18.9107 6.40482 18.9368 7.28993C19.0068 8.85993 19.0068 10.4399 19.0068 11.9999C19.0068 13.5599 19.0068 15.1399 18.9368 16.7099C18.9107 17.595 18.5393 18.4348 17.9021 19.0496C17.2648 19.6645 16.4123 20.0055 15.5268 19.9999C14.9263 19.9994 14.3366 19.8407 13.8168 19.5399C12.8168 18.9599 10.8168 17.7699 9.97684 17.2599L6.78684 15.2599C6.23951 14.9136 5.78867 14.4345 5.47626 13.8671C5.16385 13.2998 5.00002 12.6626 5.00002 12.0149C5.00002 11.3672 5.16385 10.7301 5.47626 10.1627C5.78867 9.59536 6.23951 9.11624 6.78684 8.76993C7.90684 8.05993 9.42684 7.08993 10.1268 6.65993C10.8268 6.22993 12.8568 4.99993 13.8168 4.45993C14.3366 4.15913 14.9263 4.00048 15.5268 3.99993ZM15.5268 17.9999C15.8914 18.0028 16.2426 17.8633 16.5059 17.6112C16.7692 17.3591 16.9238 17.0142 16.9368 16.6499C17.0068 15.0999 17.0068 13.5399 17.0068 11.9999C17.0068 10.4599 17.0068 8.89993 16.9368 7.34993C16.9238 6.98563 16.7692 6.64076 16.5059 6.38866C16.2426 6.13656 15.8914 5.9971 15.5268 5.99993C15.2803 5.99666 15.0379 6.06248 14.8268 6.18993C13.8268 6.74993 11.9468 7.86993 11.1668 8.34993L7.84684 10.4499C7.58697 10.616 7.37356 10.8453 7.22663 11.1164C7.0797 11.3876 7.00407 11.6916 7.00684 11.9999C7.00548 12.3119 7.08262 12.6192 7.23115 12.8936C7.37969 13.1679 7.59485 13.4005 7.85684 13.5699C8.93684 14.2499 10.3868 15.1699 11.0468 15.5699C11.7068 15.9699 13.8468 17.2399 14.8268 17.8099C15.0383 17.9364 15.2805 18.0022 15.5268 17.9999Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.PREVIOUS_EP && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4 20C4.26522 20 4.51957 19.8946 4.70711 19.7071C4.89464 19.5196 5 19.2652 5 19V5C5 4.73478 4.89464 4.48043 4.70711 4.29289C4.51957 4.10536 4.26522 4 4 4C3.73478 4 3.48043 4.10536 3.29289 4.29289C3.10536 4.48043 3 4.73478 3 5V19C3 19.2652 3.10536 19.5196 3.29289 19.7071C3.48043 19.8946 3.73478 20 4 20Z"
            fill={fill}
          />
          <path
            d="M17.52 20.0001C18.4055 20.0057 19.258 19.6646 19.8953 19.0498C20.5325 18.4349 20.9039 17.5952 20.93 16.7101C21 15.1401 21 13.5601 21 12.0001C21 10.4401 21 8.86007 20.93 7.29007C20.9039 6.40496 20.5325 5.56519 19.8953 4.95037C19.258 4.33554 18.4055 3.99446 17.52 4.00007C16.9195 4.00062 16.3297 4.15927 15.81 4.46007C14.81 5.04007 12.81 6.23007 11.97 6.74007L8.78 8.74007C8.23267 9.08638 7.78183 9.5655 7.46942 10.1329C7.15701 10.7002 6.99319 11.3374 6.99319 11.9851C6.99319 12.6328 7.15701 13.2699 7.46942 13.8373C7.78183 14.4046 8.23267 14.8838 8.78 15.2301C9.9 15.9401 11.42 16.9101 12.12 17.3401C12.82 17.7701 14.85 19.0001 15.81 19.5401C16.3297 19.8409 16.9195 19.9995 17.52 20.0001ZM17.52 6.00007C17.8845 5.99723 18.2358 6.13669 18.4991 6.38879C18.7624 6.6409 18.917 6.98576 18.93 7.35007C19 8.90007 19 10.4601 19 12.0001C19 13.5401 19 15.1001 18.93 16.6501C18.917 17.0144 18.7624 17.3592 18.4991 17.6113C18.2358 17.8634 17.8845 18.0029 17.52 18.0001C17.2735 18.0033 17.031 17.9375 16.82 17.8101C15.82 17.2501 13.94 16.1301 13.16 15.6501L9.84 13.5501C9.58014 13.384 9.36673 13.1547 9.2198 12.8836C9.07286 12.6124 8.99723 12.3084 9 12.0001C8.99864 11.6881 9.07578 11.3808 9.22432 11.1064C9.37285 10.8321 9.58802 10.5995 9.85 10.4301C10.93 9.75007 12.38 8.83007 13.04 8.43007C13.7 8.03007 15.84 6.76007 16.82 6.19007C17.0314 6.06359 17.2736 5.99785 17.52 6.00007Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.PREVIOUS_AD && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.70711 5.29289C10.0976 5.68342 10.0976 6.31658 9.70711 6.70711L5.41421 11H20.7778C21.4528 11 22 11.4477 22 12C22 12.5523 21.4528 13 20.7778 13H5.41421L9.70711 17.2929C10.0976 17.6834 10.0976 18.3166 9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071L2.29289 12.7071C2.09763 12.5118 2 12.2559 2 12C2 11.7441 2.09763 11.4882 2.29289 11.2929L8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.MOVE_L && (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_b_779_38888)">
            <rect width="32" height="32" rx="16" fill="white" fillOpacity="0.5" />
            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F1F1F4" />
          </g>
          <path
            d="M13.5174 10.2752C13.1749 10.6178 13.1521 11.1589 13.4489 11.528L13.5174 11.6043L17.9128 16L13.5174 20.3957C13.1749 20.7383 13.1521 21.2794 13.4489 21.6484L13.5174 21.7248C13.86 22.0673 14.4011 22.0901 14.7702 21.7933L14.8465 21.7248L20.5712 16L14.8465 10.2752C14.4795 9.90825 13.8844 9.90825 13.5174 10.2752Z"
            fill="#ADB0B8"
          />
          <defs>
            <filter
              id="filter0_b_779_38888"
              x="-12"
              y="-12"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_779_38888" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_779_38888" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === ArrowIconVariant.MOVE_L_DARK && (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_b_779_38888)">
            <rect width="32" height="32" rx="16" fill="#111114" shapeRendering="crispEdges" />
            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#1C1C21" />
          </g>
          <path
            d="M13.5174 10.2752C13.1749 10.6178 13.1521 11.1589 13.4489 11.528L13.5174 11.6043L17.9128 16L13.5174 20.3957C13.1749 20.7383 13.1521 21.2794 13.4489 21.6484L13.5174 21.7248C13.86 22.0673 14.4011 22.0901 14.7702 21.7933L14.8465 21.7248L20.5712 16L14.8465 10.2752C14.4795 9.90825 13.8844 9.90825 13.5174 10.2752Z"
            fill="#444553"
          />
          <defs>
            <filter
              id="filter0_b_779_38888"
              x="-12"
              y="-12"
              width="56"
              height="56"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="6" />
              <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_779_38888" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_779_38888" result="shape" />
            </filter>
          </defs>
        </svg>
      )}
      {variant === ArrowIconVariant.IMAGE_SLIDE_R && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.8417 20.6583C10.3861 20.2027 10.3861 19.464 10.8417 19.0084L15.8501 14L10.8417 8.99162C10.3861 8.53601 10.3861 7.79732 10.8417 7.34171C11.2973 6.8861 12.036 6.8861 12.4916 7.34171L18.325 13.175C18.7806 13.6307 18.7806 14.3693 18.325 14.825L12.4916 20.6583C12.036 21.1139 11.2973 21.1139 10.8417 20.6583Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.IMAGE_SLIDE_CHEVRON && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 8.16667" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.341709 0.341709C0.79732 -0.113903 1.53601 -0.113903 1.99162 0.341709L7 5.35009L12.0084 0.341709C12.464 -0.113903 13.2027 -0.113903 13.6583 0.341709C14.1139 0.79732 14.1139 1.53601 13.6583 1.99162L7.82496 7.82496C7.36935 8.28057 6.63065 8.28057 6.17504 7.82496L0.341709 1.99162C-0.113903 1.53601 -0.113903 0.79732 0.341709 0.341709Z"
            fill={fill}
          />
        </svg>
      )}
      {variant === ArrowIconVariant.TRIGGER_IMAGES_SLIDER_R && (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3905 23.6095C11.8698 23.0888 11.8698 22.2446 12.3905 21.7239L18.1144 16L12.3905 10.2761C11.8698 9.75544 11.8698 8.91122 12.3905 8.39052C12.9112 7.86982 13.7554 7.86982 14.2761 8.39052L20.9428 15.0572C21.4635 15.5779 21.4635 16.4221 20.9428 16.9428L14.2761 23.6095C13.7554 24.1302 12.9112 24.1302 12.3905 23.6095Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}

export default ArrowIcon;
